/**
 * Plan-card lines. Checks run on every plan. OMS Lite (internal key Free) keeps this week and last
 * week. Older weeks and the PDF start on Starter. Growth and Pro include that.
 */

const CHECKS = 'Temps, cooks, cools, deliveries, and cleaning'

export const foodSafetyPlanFeatureGroup = plan => {
  const normalized = String(plan || 'Free').trim()
  const paid =
    normalized === 'Starter' || normalized === 'Growth' || normalized === 'Pro'
  return {
    title: 'Food Safety',
    features: paid
      ? [CHECKS, 'Full history', 'Download or email the PDF']
      : [
          CHECKS,
          'This week and last week on the report',
          {
            text: 'Older weeks and the PDF are on Starter',
            limited: true,
          },
        ],
  }
}
